// src/wiki.js
import * as React from "react";
import {
    Datagrid,
    List,
    Show,
    Create,
    Edit,
    Filter,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    TextInput,
    BooleanField,
    BooleanInput,
    DateField,
    DateInput,
    Pagination,
    TopToolbar,
    EditButton,
    Button,
    useNotify,
    useRefresh,
    FunctionField,
    ArrayField,
    SingleFieldList,
    ChipField,
    required,
    FileInput,
    FileField,
    CreateButton,
    NumberInput,
    NumberField,
} from "react-admin";
import RichTextInput from "ra-input-rich-text";
import { makeStyles, Chip } from "@material-ui/core";
import { SortStepperField } from "./SortStepperField";

const useQuickFilterStyles = makeStyles((theme) => ({
    chip: { marginBottom: theme.spacing(1) },
}));

const QuickFilter = ({ label }) => {
    const classes = useQuickFilterStyles();
    return <Chip className={classes.chip} label={label} />;
};

const WikiFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Titel" source="title" alwaysOn resettable />
        <TextInput label="Teaser" source="teaser" resettable />
        <QuickFilter label="Nur aktiv" source="enabled" defaultValue={true} />
        <DateInput label="Erstellt ab" source="created_gte" />
        <DateInput label="Erstellt bis" source="created_lte" />
    </Filter>
);

const PostPagination = (props) => (
    <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />
);

// Optional: eigene Actions (z.B. später Export, Reload, etc.)
const WikiListActions = () => (
    <TopToolbar>
        <WikiFilter context="button" label="Filter hinzufügen" />
        <CreateButton />
    </TopToolbar>
);

const WikiTitle = ({ record }) => (
    <span>Wiki {record ? `"${record.title}"` : ""}</span>
);


// ---- LIST ----
export const WikiList = (props) => (
    <List
        {...props}
        filters={<WikiFilter />}
        sort={{ field: "sort", order: "DESC" }}
        perPage={25}
        pagination={<PostPagination />}
        actions={<WikiListActions />}
        title="Wiki"
        bulkActionButtons={false}
    >
        <Datagrid rowClick="edit">
            <BooleanField label="Aktiv" source="enabled" />
            <FunctionField
                label="Sortierung"
                render={(record) => <SortStepperField record={record} />}
            />
            {/* <TextField label="ID" source="id" /> */}
            <TextField label="Teaser" source="teaser" />
            <TextField label="Titel" source="title" />
            <FunctionField
                label="Dateien"
                render={(record) => (Array.isArray(record.files) ? record.files.length : 0)}
            />
            {/* <DateField label="Erstellt" source="created" showTime /> */}
            <DateField label="Geändert" source="updated" showTime />
            <EditButton label="" />
        </Datagrid>
    </List>
);

// ---- SHOW ----
export const WikiShow = (props) => (
    <Show {...props} title={<WikiTitle />}>
        <SimpleShowLayout className="Row">
            <TextField label="ID" source="id" />
            <BooleanField label="Aktiv" source="enabled" />
            <NumberField label="Sort" source="sort" />
            <TextField label="Teaser" source="teaser" />
            <TextField label="Titel" source="title" />
            <TextField label="Content" source="content" />

            {/* Dateien als Chips */}
            <ArrayField label="Dateien" source="files">
                <SingleFieldList>
                    <ChipField source="" />
                </SingleFieldList>
            </ArrayField>

            <DateField label="Erstellt" source="created" showTime />
            <DateField label="Updated" source="updated" showTime />
        </SimpleShowLayout>
    </Show>
);

// ---- CREATE ----
export const WikiCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <BooleanInput label="Aktiv" source="enabled" defaultValue={true} />
            <NumberInput label="Sort" source="sort" defaultValue={0} />
            <TextInput label="Teaser" source="teaser" fullWidth />
            <TextInput label="Titel" source="title" validate={[required()]} fullWidth />

            <RichTextInput label="Content" source="content" />

            <FileInput source="files" label="Dateien" multiple>
                <FileField source="src" title="title" />
            </FileInput>

        </SimpleForm>
    </Create>
);

// ---- EDIT ----
export const WikiEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();

    const onSuccess = () => {
        notify("Änderungen wurden gespeichert.");
        refresh();
    };

    return (
        <Edit
            {...props}
            mutationMode="pessimistic"
            onSuccess={onSuccess}
            title={<WikiTitle />}
        >
            <SimpleForm>
                <div className="Row">
                    <BooleanField label="Aktiv" source="enabled" />
                    {/* <TextField label="ID" source="id" /> */}
                </div>

                <div className="Col">
                    <BooleanInput label="Aktiv" source="enabled" />
                    <NumberInput label="Sort" source="sort" defaultValue={0} />
                    <TextInput label="Teaser" source="teaser" />
                </div>

                <TextInput label="Titel" source="title" validate={[required()]} fullWidth />

                <RichTextInput label="Content" source="content" />

                {/* Dateien anzeigen (Namen) */}
                <ArrayField label="Dateien (aktuell)" source="files">
                    <SingleFieldList>
                        <ChipField source="" />
                    </SingleFieldList>
                </ArrayField>

                {/* Optional Upload wie oben (abhängig vom dataProvider) */}

                <FileInput source="files" label="Dateien hinzufügen" multiple>
                    <FileField source="src" title="title" />
                </FileInput>


                {/* <DateField label="Erstellt" source="created" showTime /> */}
                <DateField label="Geändert" source="updated" showTime />
            </SimpleForm>
        </Edit>
    );
};
